import { Tokens } from "~/services/api/types/tokens";

/**
 * Whether the access token is past its expiry, judged on the DEVICE clock.
 *
 * The one expiry rule for the app: the server-render cookie reader and checkout
 * telemetry both go through it. The client fetch layer deliberately does not —
 * it sends the token and lets a 401 from the backend end the session.
 *
 * A missing, zero or otherwise falsy `tokenExpires` means "cannot tell", not
 * "expired": epoch 0 is not a real expiry, and reporting such a session as dead
 * would invent a problem the backend does not have.
 *
 * Note the device-clock caveat before drawing conclusions from this: a machine
 * with a badly wrong clock reports the wrong answer, so a cluster of tokens
 * "expired by hours" may be broken clocks rather than broken session handling.
 */
export function isTokenExpired(
    tokens: Pick<Tokens, "tokenExpires"> | null | undefined
): boolean {
    const tokenExpires = tokens?.tokenExpires;
    if (!tokenExpires) return false;
    return tokenExpires <= Date.now();
}

export default isTokenExpired;
